import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { baseUrl } from "./baseUrl";
import axios from "axios";

const CombackModal = (props) => {
    const [item, setItem] = useState([]);
    useEffect(() => {
        setItem(props.item);
    }, [props]);
    const [count, setCount] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const returnHandler = (e) => {
        setLoading(true);
        e.preventDefault();
        if (!count || !description) {
            toast.error("لطفا تمام فیلدها را پر کنید.", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false);
        } else {
            if (count > item.order_count) {
                toast.error("تعداد وارد شده بیشتر از تعداد کالاست.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLoading(false);
            } else {
                let data = new FormData();
                data.append("product_id", item.id);
                data.append("count", count);
                data.append("reason", description);
                data.append("status", "comeback");
                let config = {
                    url: `${baseUrl}/orders/${props.id}/return`,
                    method: "POST",
                    data: data,
                };
                axios(config)
                    .then((res) => {
                        toast.success(res.data.message, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setLoading(false);
                        setTimeout(() => {
                            window.location.reload(false);
                        }, 2000);
                    })
                    .catch((err) => {
                        toast.error(err.response.data.message, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setLoading(false);
                    });
            }
        }
    };
    return (
        <div className="factor-main">
            <div className="fac-modal">
                <span className="title">برگشتی</span>
                <span className="name">{item.name}</span>
                {/* <span className="date">1402/02/12 - 22:26</span> */}
                <div className="inp-div">
                    <input
                        onChange={(e) => setCount(e.target.value)}
                        value={count}
                        type="text"
                        className="text-center"
                        name="serial"
                        placeholder={"تعداد (حداکثر " + item.order_count + ")"}
                    />
                </div>
                <textarea
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    placeholder="توضیحات"
                    className="text-box-div text-area-d"
                ></textarea>
                {!loading ? (
                    <button onClick={returnHandler} className="submit">
                        ثبت برگشتی
                    </button>
                ) : (
                    <button className="submit">
                        <img src="/assets/images/loading.gif" width={20} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default CombackModal;
